import React, { Component } from 'react';

class BackButton extends Component {
  render() {
    const text = '一覧に戻る';

    return (
      <div
        className="BackButtonContainer"
      >
        <div
          className="BackButton"
          onClick={this.props.onClick}
        >
          {text}
        </div>
      </div>
    );
  }
};


export default BackButton;
